<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <h4 class="m-b-0 text-white"> Comisiones </h4>
            </div>
            <div class="card-body">
                <!-- class="center center-block" -->
                <form #loginForm="ngForm" (ngSubmit)="iniciarSesion()">
                    <!--  -->
                    <div class="form-structor center">
                        <!--  float float-right -->
                        <div class="signup">
                            <h2 class="form-title" id="signup"><span>or</span>Comisiones</h2>
                            <div class="form-holder">
                                <select class="form-control" name="sucursal" [(ngModel)]="currentSucursal[0].codSuc" required>
                                            <option value="" disabled selected>Selecciona sucursal</option>
                                            <option *ngFor="let s of sucursales" [ngValue]="s.id">{{ s.nombre }}</option>
                                        </select>
                                <input class="sinborde" type="password" name="codigoSuc" [(ngModel)]="currentSucursal[0].codSeguridad" placeholder="Contraseña" required>
                            </div>
                            <button class="submit-btn" type="submit">Iniciar</button>
                            <!-- [disabled]="!loginForm.valid" -->
                        </div>
                        <div class="login slide-up">
                            <div class="center">
                                <div class="form-holder">
                                    <input type="email" class="input" placeholder="Email" />
                                    <input type="password" class="input" placeholder="Password" />
                                </div>
                                <button class="submit-btn" type="submit">Iniciar</button>
                                <!-- [disabled]="!loginForm.valid" -->
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/comisiones/comisiones.component.html